import { render, staticRenderFns } from "./KnowleDoc.vue?vue&type=template&id=5b53ff3c&scoped=true"
import script from "./KnowleDoc.vue?vue&type=script&lang=js"
export * from "./KnowleDoc.vue?vue&type=script&lang=js"
import style0 from "./KnowleDoc.vue?vue&type=style&index=0&id=5b53ff3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b53ff3c",
  null
  
)

export default component.exports